import {Serializer} from 'src/app/shared/model/serializer';
import { DimonaAdmin } from './dimonaAdmin.model';

export class DimonaAdminSerializer implements Serializer {

  fromJson(json: any): DimonaAdmin {
    const dimonaAdmin: DimonaAdmin = new DimonaAdmin();

    dimonaAdmin.dimonaId = json.dimonaId;
    dimonaAdmin.periodId = json.periodId;
    dimonaAdmin.dimonaType = json.dimonaType;
    dimonaAdmin.dimonaStatus = json.dimonaStatus;
    dimonaAdmin.startDate = json.startDate;
    dimonaAdmin.endDate = json.endDate;
    dimonaAdmin.dimonaPeriodId = json.dimonaPeriodId;
    dimonaAdmin.reference = json.reference;

    return dimonaAdmin;
  }

  toJson(dimonaAdmin: DimonaAdmin): any {
    return {
      dimonaId: dimonaAdmin.dimonaId,
      periodId: dimonaAdmin.periodId,
      dimonaType: dimonaAdmin.dimonaType,
      dimonaStatus: dimonaAdmin.dimonaStatus,
      startDate: dimonaAdmin.startDate,
      endDate: dimonaAdmin.endDate,
      dimonaPeriodId: dimonaAdmin.dimonaPeriodId,
      reference: dimonaAdmin.reference,
    };
  }

}
